"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _withStyle = _interopRequireDefault(require("../utils/withStyle"));

var _excluded = ["origin"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var NotifyExport = function NotifyExport(_ref) {
  var _ref$origin = _ref.origin,
      origin = _ref$origin === void 0 ? false : _ref$origin,
      props = _objectWithoutProperties(_ref, _excluded);

  if (origin) {
    return /*#__PURE__*/React.createElement("svg", _extends({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "data-icon": "NotifyExport"
    }, props), /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#id-NotifyExport-a)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M19.45 11.406c.232.809.03 1.516-.28 2.298-1.69 1.895-3.788.118-7.05 1.792-3.26 1.673-7.683-.133-8.97-3.28a6.067 6.067 0 0 1 2.768-7.074A6.052 6.052 0 0 1 14.741 8.7l.954-.03a3.783 3.783 0 0 1 3.754 2.736Z",
      fill: "azure",
      stroke: "#02C8C6",
      strokeOpacity: 0.16,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.272 4.887c.849.342-6.766-.352-6.67 5.021 0 0 .06 3.33 3.406 4.104 3.345.774 4.14-1.323 6.647-.951 2.505.371 4.535-2.58 4.535-2.58l.796 2.376-1.146 1.379c-2.139 1.287-1.59-.28-6.64 1.367-5.047 1.647-7.683-.133-8.97-3.28A6.067 6.067 0 0 1 5.997 5.25a6.052 6.052 0 0 1 5.274-.362Z",
      fill: "#02C8C6",
      fillOpacity: 0.08,
      style: {
        mixBlendMode: 'darken'
      }
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.037 12.497 4.937 7.72 2.804 5.242l-.944 4.39 5.073 11.014 17.949-8.267-1.504-3.264-7.34 3.382Z",
      fill: "#00112F",
      fillOpacity: 0.08,
      style: {
        mixBlendMode: 'overlay'
      }
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.747 10.81a1.056 1.056 0 0 0-1.493 0L6.81 15.253a1.055 1.055 0 1 0 1.492 1.493l2.643-2.643v6.34a1.056 1.056 0 0 0 2.111 0v-6.34l2.643 2.643a1.055 1.055 0 1 0 1.492-1.493l-4.444-4.445Z",
      fill: "#ABE4EF",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "id-NotifyExport-a"
    }, /*#__PURE__*/React.createElement("path", {
      fill: "#fff",
      d: "M0 0h24v24H0z"
    }))));
  }

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "data-icon": "NotifyExport"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id-NotifyExport-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 11.406c.232.809.03 1.516-.28 2.298-1.69 1.895-3.788.118-7.05 1.792-3.26 1.673-7.683-.133-8.97-3.28a6.067 6.067 0 0 1 2.768-7.074A6.052 6.052 0 0 1 14.741 8.7l.954-.03a3.783 3.783 0 0 1 3.754 2.736Z",
    strokeOpacity: 0.16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.272 4.887c.849.342-6.766-.352-6.67 5.021 0 0 .06 3.33 3.406 4.104 3.345.774 4.14-1.323 6.647-.951 2.505.371 4.535-2.58 4.535-2.58l.796 2.376-1.146 1.379c-2.139 1.287-1.59-.28-6.64 1.367-5.047 1.647-7.683-.133-8.97-3.28A6.067 6.067 0 0 1 5.997 5.25a6.052 6.052 0 0 1 5.274-.362Z",
    fillOpacity: 0.08,
    style: {
      mixBlendMode: 'darken'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.037 12.497 4.937 7.72 2.804 5.242l-.944 4.39 5.073 11.014 17.949-8.267-1.504-3.264-7.34 3.382Z",
    fillOpacity: 0.08,
    style: {
      mixBlendMode: 'overlay'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.747 10.81a1.056 1.056 0 0 0-1.493 0L6.81 15.253a1.055 1.055 0 1 0 1.492 1.493l2.643-2.643v6.34a1.056 1.056 0 0 0 2.111 0v-6.34l2.643 2.643a1.055 1.055 0 1 0 1.492-1.493l-4.444-4.445Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id-NotifyExport-a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
};

var _default = (0, _withStyle["default"])(NotifyExport);

exports["default"] = _default;